module.exports = new __parcel__URL__("coco.2fe5eef7.jpg").toString();